<div>
    <ul ngbNav #navTabs="ngbNav" [activeId]="0" [destroyOnHide]="false" class="nav nav-tabs nav-fill"
        ng-class="{'ngb-stack': vertical, 'ngb-justify': justified, 'nav-pairs': false, 'nav-solo': false}">
        <!-- General Tabs + Content -->
        <li *ngFor="let category of tabs.generals; index as categoryIndex" [ngbNavItem]="categoryIndex"
            [ngClass]="{'extended-tabs': tabs.others.length > 0}">
            <a class="mmb-dm-content-link" ngbNavLink>
                {{category.name}}
            </a>
            <ng-template ngbNavContent>
                <div *ngFor="let menu of category.menu; let lastMenu = last">
                    <span class="ib-digital-menu-mmb__menu-list--dish">{{menu.name}}</span>
                    <span class="ib-digital-menu-mmb__menu-list--explanation">{{menu.subtitle}}</span>
                    <div *ngFor="let item of menu.items; let lastItem = last">
                        <ib-digital-menu-item [item]="item"></ib-digital-menu-item>
                        <hr *ngIf="this.item.inventoryKey || (!this.item.inventoryKey && lastItem && !lastMenu) "
                            class="ib-digital-menu-mmb__menu-list--option__separator"
                            [ngClass]="{'ib-digital-menu-mmb__menu-list--option__separator--last': lastItem}" />
                    </div>
                </div>
                <!-- Express Menu -->
                <div *ngIf="expressMenu && category.code === 'TAKE_OFF'" ibFocusin tabindex="0"
                    class="ib-digital-menu-mmb__express-menu">
                    <div class="ib-flex ib-flex--align-center">
                        <span class="icon-informacion ib-text--color-important"></span>
                        <p class="ib-digital-menu-mmb__express-menu__title ib-heading ib-text--color-important">
                            {{'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_EXPRESS_MENU_TITLE' | translate}}</p>
                    </div>
                    <p class="ib-digital-menu-mmb__express-menu__msg ib-text ib-text--lh-normal">
                        {{expressMenu}}
                    </p>
                </div>
                <!-- End Express Menu -->
                <ib-digital-menu-allergens-info [show_allergens]=true [disclaimer]="disclaimer">
                </ib-digital-menu-allergens-info>
            </ng-template>
        </li>

        <!-- Dropdown Tab Content -->
        <li *ngFor="let tab of tabs.others; index as otherTabIndex" [ngbNavItem]="otherTabIndex+2"
            style="display: none;">
            <ng-template ngbNavContent>
                <div *ngIf="tab.code !=='WINES' && tab.code !== 'BAR_SERVICE'">
                    <div *ngFor="let menu of tab.menu; let lastMenu = last">
                        <span class="ib-digital-menu-mmb__menu-list--dish">{{menu.name}}</span>
                        <span class="ib-digital-menu-mmb__menu-list--explanation">{{menu.subtitle}}</span>
                        <div *ngFor="let item of menu.items; let lastItem = last">
                            <ib-digital-menu-item [item]="item"></ib-digital-menu-item>
                            <hr *ngIf="this.item.inventoryKey || (!this.item.inventoryKey && lastItem && !lastMenu) "
                                class="ib-digital-menu-mmb__menu-list--option__separator"
                                [ngClass]="{'ib-digital-menu-mmb__menu-list--option__separator--last': lastItem}" />
                        </div>
                    </div>
                </div>

                <!-- Drinks Section -->
                <div *ngIf="tab.code === 'BAR_SERVICE'">
                    <div *ngFor="let menu of tab.menu; let last = last;" class="">
                        <span class="ib-digital-menu-mmb__menu-list--dish">{{menu.name}}</span>
                        <div [ngClass]="{'ib-digital-menu-mmb__menu-list--drinks-grid': last}">
                            <div *ngFor="let item of menu.items; let i = index"
                                [ngClass]="{'ib-digital-menu-mmb__menu-list--drinks-grid__column': last}">
                                <div [ngClass]="{'ib-digital-menu-mmb__menu-list--drinks-grid__section': last}">
                                    <span class="ib-digital-menu-mmb__menu-list--section-title"
                                        [ngClass]="{'ib-digital-menu-mmb__menu-list--section-title__space': i!==0 && !last}">{{item.name}}</span>
                                    <ul class="ib-digital-menu-mmb__menu-list--section-list"
                                        *ngFor="let description of item.description">
                                        <li class="ib-digital-menu-mmb__menu-list--drinks-grid__item">{{description}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <hr class="ib-digital-menu-mmb__menu-list--option__separator"
                            [ngClass]="{'ib-digital-menu-mmb__menu-list--option__separator--last': last}" />
                    </div>
                </div>
                <!-- End Drinks Section -->

                <!-- Wines Component -->
                <ib-digital-menu-wine *ngIf="tab.code ==='WINES'" [menu]="tab.menu"> </ib-digital-menu-wine>
                <!-- End Wines Component -->

                <!-- Allergens Info -->
                <ib-digital-menu-allergens-info
                    [show_allergens]="(tab.code === 'WINES' || tab.code === 'BAR_SERVICE') ? false : true"
                    [disclaimer]="disclaimer">
                </ib-digital-menu-allergens-info>
                <!-- End Allergens Info -->
            </ng-template>
        </li>

        <!-- Dropdown Tabs -->
        <li *ngIf="tabs.others.length > 0" class="dropdown" [class.active]="isOtherTabSelected()">
            <a class="dropdown-toggle" id="navbarDropdown" data-toggle="dropdown">
                <span class="ib-tab__text-align">
                    {{'MODAL_DIGITAL_MENU_MORE_TABS' | translate}}
                </span>
            </a>
            <ul class="dropdown-menu dropdown-menu-right dropdown-menu-bottom" aria-labelledby="navbarDropdown">
                <li *ngFor="let tab of tabs.others; index as dropDownIndex" [ngbNavItem]="dropDownIndex+2">
                    <a ngbNavLink>
                        {{tab.name}}
                    </a>
                </li>
            </ul>
        </li>
        <!-- End Dropdown Tabs -->

    </ul>
    <!-- Tab Content Show by navItem index -->
    <div class="tab-container">
        <span class="hidden-tav-name" *ngIf="isOtherTabSelected()">
            {{ getOtherTabSelectedName() }}
        </span>
        <div [ngbNavOutlet]="navTabs">
        </div>
    </div>
</div>
